let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9ss5U")).then(() => parcelRequire('fcyuR'));